import { render } from "./ModalLoginHelp.vue?vue&type=template&id=c9a5b34a"
import script from "./ModalLoginHelp.vue?vue&type=script&lang=js"
export * from "./ModalLoginHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__